module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0288afb0be1ab93b1160026b13c8eb22.png";